import React from 'react';
import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
} from "@material-ui/core";
import Tooltip from '@material-ui/core/Tooltip';
import RemoveIcon from "@material-ui/icons/Close";
import {appConstants} from "../../_constants";
import {PrimaryLabel, DefaultLabel} from "../../utils/LabelPanel"
const SelectedAirlineRoute = ({classes, routes, removeSelectedRoute }) => {
    return (
        <div style={{marginBottom: '15px'}}>
            <Table className={classes.table} aria-labelledby="tableTitle">
                <TableHead className={classes.negativeColor} color="regional">
                    <TableRow>
                        <TableCell padding="none">S/N</TableCell>
                        <TableCell padding="none">Departure</TableCell>
                        <TableCell padding="none">Destination</TableCell>
                        <TableCell padding="none">IsRegional</TableCell>
                        <TableCell padding="none">Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {routes.map((item, key) => {
                        console.log("item", item);
                        return(
                        
                            <TableRow hover key={key}>
                                <TableCell>{key + 1}</TableCell>
                                <TableCell padding="none" className={'text-capitalize'}>{item.Departure.Name}</TableCell>
                                <TableCell padding="none" className={'text-capitalize'}>{item.Destination.Name}</TableCell>
                                <TableCell padding="none" className={'text-capitalize'}>
                                {
                                item.IsRegional &&
                                <PrimaryLabel message={'Yes'}/>
                            }
                            {
                                !item.IsRegional &&
                                <DefaultLabel message={'No'}/>
                            }</TableCell>
                                <TableCell padding="none" className={'text-capitalize'}>
                                    <span>
                                         &nbsp;&nbsp;<Tooltip title="Remove" placement="top">
                                            <span
                                                onClick={() => removeSelectedRoute(item.Id_)}
                                                className={classes.icon}
                                                style={{color: `${appConstants.DANGER_COLOR}`, cursor: 'pointer'}}>
                                                <RemoveIcon/>
                                            </span>
                                         </Tooltip>
                                     </span>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </div>
    );
};

export default SelectedAirlineRoute;



// WEBPACK FOOTER //
// ./src/Regional-Views/AirlineRouteSettings/SelectedAirlineRoutes.js